import { v4 as uuidv4 } from 'uuid';
import { GetStateFunction, RootState } from 'gf-types';
import { PublicForm } from '../../../types/form-types';
import { disableStep } from '../actions';
import { FORM_CLOSE, FORM_SAVE_FAILURE, FORM_SAVE_REQUEST, FORM_SAVE_SUCCESS } from '../../../formeditor/actions';
import { publicShareApimCall } from '../../../helpers/api';
import { FormEditorDispatch } from '../../../formeditor/formeditor-types';

// This is a special actions file that combine both the form editor and hipaa setup actions together to coordinate
// submitting the baa public form and saving the setup record to the db

// these are form editor actions used only by hipaa
export const FORM_HIPAA_INIT = 'FORM_HIPAA_INIT';
export const FORM_HIPAA_CLOSE = 'FORM_HIPAA_CLOSE';
export const FORM_HIPAA_PDF_PATH = 'FORM_HIPAA_PDF_PATH';

export const initHipaaForm = () => (dispatch: FormEditorDispatch) => {
  dispatch({ type: FORM_HIPAA_INIT, payload: { signatureFieldName: 'Signature' } });
};

export const submitBaaForm = () => async (dispatch: FormEditorDispatch, getState: GetStateFunction) => {
  const state: RootState = getState();
  const { sessionId } = state.formeditor;
  const baaPublicForm = { ...state.formeditor.form } as PublicForm;

  baaPublicForm.sessionId = sessionId;
  baaPublicForm.trackingId = localStorage.getItem('trackingId');

  if (!localStorage.getItem('trackingId')) {
    localStorage.setItem('trackingId', uuidv4());
  }

  dispatch(disableStep(true));

  dispatch({
    type: FORM_SAVE_REQUEST,
    payload: {
      isNewForm: false,
      isSaving: true,
      isFetching: false,
      error: null
    }
  });

  try {
    const response = await publicShareApimCall('/forms', 'POST', baaPublicForm);

    dispatch({
      type: FORM_SAVE_SUCCESS,
      payload: {
        isSaving: false,
        isDirty: false,
        lastSaveDate: new Date(),
        isUnsaved: false,
        publicShareSubmitted: true,
        pdfPath: response.data.location
      }
    });

    dispatch({ type: FORM_CLOSE });
    dispatch({ type: FORM_HIPAA_CLOSE });
  } catch (error) {
    // todo - handle this in the hipaaSetupReducer as well
    dispatch({
      type: FORM_SAVE_FAILURE,
      payload: {
        isSaving: false,
        error: { message: error?.response?.data },
        isFetching: false
      }
    });
  }
};

export const closeHipaaForm = () => (dispatch: FormEditorDispatch) => {
  dispatch({ type: FORM_HIPAA_CLOSE });
};
